export default {
  // Navbar
  'nav.features': '機能',
  'nav.technology': '技術',
  'nav.useCases': 'ユースケース',
  'nav.demo': 'デモ',
  'nav.contact': 'お問い合わせ',
  'nav.docs': 'ドキュメント',

  // Hero
  'hero.title': 'Your Age, Verified.',
  'hero.title2': 'Your Identity, Protected.',
  'hero.subtitle': 'ZK Faceは、顔を公開せずに「19歳以上」のみを検証するゼロ知識ベースの認証技術です。',
  'hero.cta.demo': 'Try Full Demo',
  'hero.cta.contact': 'Contact Partnership',
  'hero.ageGuess.title': '私は何歳に見える?',
  'hero.ageGuess.upload': '写真をアップロード',
  'hero.ageGuess.badge': '写真はサーバーに送信されません',
  'hero.ageGuess.result': 'AIが推定した年齢',
  'hero.ageGuess.confidence': '信頼区間',
  'hero.ageGuess.privacy1': 'No Storage',
  'hero.ageGuess.privacy2': '100% Local ML',
  'hero.ageGuess.privacy3': 'No Identity Exposure',

  // Problem
  'problem.title': 'The Internet Keeps Asking for Your Identity.',
  'problem.title2': 'But Why Should You Give It Away?',
  'problem.description': 'ほとんどのオンラインサービスは、依然として社会保障番号、顔の原本、生年月日などの高リスクな個人情報を要求しています。ユーザーは不安を感じ、サービス提供者は過度な責任を負うことになります。',
  'problem.point1.title': '個人情報漏洩リスク',
  'problem.point1.desc': '中央サーバーに保存された機密情報は、常にハッキングの危険にさらされています。',
  'problem.point2.title': '中央サーバー保存',
  'problem.point2.desc': '顔と身元情報が第三者のサーバーに永久的に保管されます。',
  'problem.point3.title': 'グローバル規制の強化',
  'problem.point3.desc': 'GDPR、CCPAなどのプライバシー規制がますます厳しくなっています。',
  'problem.point4.title': 'Web3の非効率性',
  'problem.point4.desc': 'レガシーKYCシステムは、分散型環境には適していません。',

  // Solution
  'solution.title': 'Prove Your Age. Reveal Nothing.',
  'solution.description': 'ZK Faceは、次の3つの原則に基づいて動作します。',
  'solution.card1.title': 'Zero-Knowledge Proof',
  'solution.card1.desc': '年齢を証明しますが、身元情報は公開しません。',
  'solution.card2.title': 'Local Machine Learning',
  'solution.card2.desc': '顔分析はすべてユーザーのデバイスでのみ実行されます。',
  'solution.card3.title': 'Data-Free Certification',
  'solution.card3.desc': 'サーバーは写真を保存せず、Proofのみを確認します。',

  // How It Works
  'howItWorks.title': 'How It Works',
  'howItWorks.subtitle': 'このプロセス全体は、サーバーと顔情報が一度も交差しないように設計されています。',
  'howItWorks.step1.title': '顔の撮影',
  'howItWorks.step1.desc': 'ユーザーのローカルデバイスで画像が準備されます。',
  'howItWorks.step2.title': 'MLモデルが特徴値を分析',
  'howItWorks.step2.desc': '顔を保存せず、特徴値のみを生成します。',
  'howItWorks.step3.title': 'ZK-Proof生成',
  'howItWorks.step3.desc': 'デバイス内部で「このユーザーは19歳以上である」という証明のみが抽出されます。',
  'howItWorks.step4.title': 'サーバー検証',
  'howItWorks.step4.desc': 'Proofのみが送信され、元の情報はサーバーに送信されません。',

  // Use Cases
  'useCases.title': 'Use Cases',
  'useCases.subtitle': 'ZK Faceは様々な業界で活用できます。',
  'useCases.case1.title': 'Adult Verification for Web/Apps',
  'useCases.case1.desc': 'ウェブサイトやアプリで成人認証を安全に処理します。',
  'useCases.case2.title': 'Web3 Wallet Login + Age Gate',
  'useCases.case2.desc': '分散型ウォレットと連携した年齢認証システムです。',
  'useCases.case3.title': 'Streaming·Gaming Age Control',
  'useCases.case3.desc': 'ストリーミングやゲームプラットフォームの年齢制限機能です。',
  'useCases.case4.title': 'Offline Kiosk Verification',
  'useCases.case4.desc': 'オフラインキオスクでも安全な認証が可能です。',
  'useCases.case5.title': 'Government Light-KYC Services',
  'useCases.case5.desc': '政府サービス向けの軽量化された本人確認ソリューションです。',
  'useCases.badge1': 'No Face Storage',
  'useCases.badge2': 'ZKP Verified',

  // Contact
  'contact.title': "Let's Build a Privacy-First Future Together.",
  'contact.subtitle': 'パートナーシップのお問い合わせや技術的な質問がございましたら、お気軽にご連絡ください。',
  'contact.form.name': '名前',
  'contact.form.email': 'メールアドレス',
  'contact.form.company': '会社名',
  'contact.form.message': 'メッセージ',
  'contact.form.submit': '送信',
  'contact.form.submitting': '送信中...',
  'contact.form.success': 'お問い合わせが正常に送信されました！',
  'contact.form.error': '送信中にエラーが発生しました。もう一度お試しください。',
  'contact.cta.contact': 'Contact Us',
  'contact.cta.deck': 'Download Partnership Deck',

  // Footer
  'footer.description': 'ゼロ知識ベースの顔認証技術でプライバシーを保護します。',
  'footer.product': '製品',
  'footer.product.features': '機能',
  'footer.product.technology': '技術',
  'footer.product.useCases': 'ユースケース',
  'footer.product.demo': 'デモ',
  'footer.resources': 'リソース',
  'footer.resources.docs': 'ドキュメント',
  'footer.resources.api': 'API',
  'footer.resources.sdk': 'SDK',
  'footer.resources.blog': 'ブログ',
  'footer.company': '会社',
  'footer.company.about': '会社概要',
  'footer.company.careers': '採用情報',
  'footer.company.press': 'Press Kit',
  'footer.company.contact': 'お問い合わせ',
  'footer.legal': '法的事項',
  'footer.legal.privacy': 'プライバシーポリシー',
  'footer.legal.terms': '利用規約',
  'footer.legal.security': 'セキュリティ',
  'footer.copyright': '© 2025 ZK Face. All rights reserved.',
  'footer.poweredBy': 'Website Builder',
};
